
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Klar`,
'deleteKey': `⌦ Slet`,
'downKey': `↓ Ned`,
'endKey': `⤓ Slut`,
'enterKey': `Indtast`,
'escapeKey': `⎋ Flugt`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generer en 
          <code>LICENSE 
          </code> fil 
        `,
'homeKey': `⤒ Hjem`,
'keyCommand': `⌘ Kommando/Win`,
'keyControl': `^ Kontrol`,
'keyOption': `⌥ Option/Alt`,
'keyShift': `⇧ Skift`,
'leftKey': `← Venstre`,
'pagedownKey': `Pagedown`,
'pageupKey': `▲ Opslag`,
'rightKey': `→ Højre`,
's00065e45db8c0441': `Se udviklerværktøjer for flere detaljer`,
's001dd78415a91fa0': `Rullefeltets rende`,
's002fa7d1054ed082': `Boks med kant`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kasakhisk`,
's01b56d233c6c5cac': `Opdeling i sektioner`,
's01d32b35baa3b676': `Forfatter`,
's02106cc2ef0e7578': `Ny nål...`,
's02ab1ea8e5100fc1': `Marker valget som en 'tovejs tilsidesættelse'`,
's0312976fe9da5951': `Knap`,
's03608a32f05eded2': `Knib zoom`,
's036d35e03be98d22': `Matematisk dybde`,
's037b1dc850a89273': `Alternativ under`,
's0396202b716732ec': `Marker markeringen som slået igennem`,
's03f49e598ffb11cc': `Polsk`,
's0448f1059fa01720': `Gem, del eller udskriv din explorable. Rediger oplysninger som titel, sprog eller licens.`,
's0458872c43beadef': `Indsæt række før`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Afstand mellem ord`,
's05e9759cfd99c48f': `Retfærdiggør`,
's063fa5a0a4903bf4': `Sidelæns, fra venstre mod højre`,
's064339c229374050': `Kodning`,
's06634274f19b0572': `Valg af stift`,
's06743b24499f0035': `Ankercenter`,
's07808b0ca6da8fef': `Indhegnet hjemmeside`,
's07970793b21351fd': `Ruby base container`,
's079cf7850d9327f0': `Skrifttype`,
's07aa10850d9ddcc7': `Form`,
's07e6118e838b2e23': `Navigation`,
's0816468df86e4036': `Åbner indstillingerne`,
's082869038c117fe5': `Portugisisk (Brasilien)`,
's086e6c267ade2609': `Mætning`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Lyd`,
's0978fb5ba3145996': `Indsæt en liste (uordnet)`,
's09c3f1d21de14ae1': `Marker markeringen som understreget`,
's0a2d91c6720033e9': `Trimning af tekstafstand`,
's0a3ddcba94027d95': `Objektets pasform`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Indsæt en navigation`,
's0a7db790db1fc45c': `Marker markeringen som et spænd`,
's0b1271f50a77dc73': `Boks med indhold`,
's0b24d08ea349b455': `Alt, hvad du kan indsætte. Først er der ikke-interaktive elementer som lister eller billeder, dernæst er der interaktive elementer kaldet widgets. Du kan få nye ved at klikke på søgefeltet.`,
's0bdca49248ba4820': `Genveje`,
's0befccf152b6c0a9': `Orientering fra metadata`,
's0c11e479416c8421': `Indsæt en tabeltekst`,
's0c27336067c59611': `Rullepolstring`,
's0c4593d81f147042': `Baseline`,
's0c4b2e98d4ab7f5a': `App-kommandoer`,
's0c883713b83616a8': `Gem det aktive dokument`,
's0ca5c0460199cba1': `Forkortelse`,
's0cf10c4f40588f8d': `Billedtekst til tabel`,
's0d86afa3c6a1e28b': `Flex-retning`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Dit udforskbare dokument. Her kan du skrive tekst og copy/paste, redigere osv.`,
's0dc452999c129e15': `Aktiver live genindlæsning`,
's0de0febab8a4beaf': `Fejl ved læsning af denne pakke`,
's0e44968489e076a8': `Kinesisk`,
's0e4862e87c7d53ce': `Marker markeringen som et citat`,
's0e6ea8870dbddab2': `Kommandoer til dokumenter`,
's0ee28503778e4c0c': `Sidste baseline`,
's0ef01c03299bbb83': `Udsmykning`,
's0f17f32919661cff': `Mongolsk`,
's0f350bc4e538e3ea': `Ord`,
's105a06836c40fcb4': `Indstil filtre, farve og blanding af udvalgte elementer`,
's106b274b5af798e5': `Sætninger`,
's1082e1649793dca9': `Marker valget som en defineret term`,
's10f3845975a0351e': `Rediger metadata`,
's1125d159f7e64df5': `Skærm`,
's11326fd2590f4e5e': `Standard`,
's1155ec07a221e739': `Rullebjælke`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Synlighed`,
's123bea44f38abccf': `Indsæt objekt`,
's1245e2cb9f20197e': `Juster`,
's12946ec1b850962c': `Indsæt kolonne efter`,
's1351209ef74ee729': `Spænd over alle kolonner`,
's13c60cb409e8cb6f': `Juster midten`,
's13ebd619c8a06a6d': `Gitter med automatiske rækker`,
's13ef8ca26ca8861b': `Klippet element`,
's151bc2eea7a032a4': `-...uændret...`,
's153bc3c3aa39587b': `Bordhoved`,
's156647179b21d351': `Indsæt en tabelkrop`,
's158b6ec6b1fffcb2': `Pause efter`,
's15d0c0657c1ee08c': `API-nøgle`,
's1626a7e10a9f9dcc': `Indstiller markeringens skrifttypefamilie`,
's1637c7d1a30629e2': `Ramme-boks`,
's1641ab440bf4daa4': `Opdater denne widget-pakke`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avanceret: Vis pakker med versioner som 0.x.x i pakkehåndteringen`,
's16b9446e3a70e1f4': `Egenskaber`,
's16f205466761e583': `Ingen optisk skriftstørrelse`,
's16f2f1c2c516d307': `Åbn et dokument`,
's1749014f3f87fa6a': `Stræk`,
's17597a8bb4810524': `Licens`,
's17bfaaa4e7528bc7': `Basjkir`,
's17fb3f4805f4f4b9': `Fjern feltet`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Opret pakke`,
's18d5c44aae3dc82a': `Online ved redigering`,
's1988d71ef8060edf': `Indsæt en tabelrække`,
's19abee1277c9bca2': `Samoansk`,
's19daf2f26c19543d': `Oversigt`,
's1a1acc902e6668e0': `Vis avanceret tekstformatering`,
's1a5230a71d9285c1': `Indfangning`,
's1aa1cb63ad44bc6f': `Mellemrum i søjlen`,
's1af8b67d1c85c811': `Mellemrum mellem`,
's1b4a36fce2456660': `Skriftfamilie`,
's1c246045629b0016': `Marker markeringen som en sletning`,
's1c3fc313a9184670': `Offentligt link`,
's1c65f5004a07dcfa': `Skotsk gælisk`,
's1c690963f1e2df00': `Platformsspecifikt udseende`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Vil du have en kort, guidet tur?`,
's1d19244f549ec535': `Uddannelse`,
's1d5c7b28e8b50d6d': `Associate Deg.`,
's1db591f5a54dbfd3': `Indholdsboks`,
's1dbb9f50e16c92a3': `Grænseradius`,
's1dfb744260fb3a01': `Tovejs-isolat`,
's1e9c2c654732cc5f': `Hviderussisk`,
's1eaccbf2d6af8ab5': `Information`,
's1efbfc3937d565bd': `Baggrund`,
's1f2b49c1bca2035d': `Catalansk`,
's1f74bdf32b51a5fc': `Baggrundsbillede`,
's1f7698c061c208c9': `Åben`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsikansk`,
's21d61916eb8d137d': `Bordkrop`,
's21d723a1dbcd89c8': `Javanesisk`,
's21f8a2eaf5a70749': `Indsæt en etiket`,
's2206c42e5b835e6e': `Marker valget som en forkortelse`,
's22a2348c46a912a0': `Indsæt en sektion`,
's233ae776268cd44b': `Virksomhed`,
's236ed7ba747099b0': `Skrifttypevægt`,
's2492f5fb1b05b45e': `Tekst`,
's24949d7adbb5a098': `Værktøjskasse`,
's252a52330d32b900': `Metadata`,
's2540844a4bc4d9ba': `Kræve tilskrivning?`,
's255857544a9d5ec0': `Nulstil`,
's255c77900f2b5e0f': `Farveskema`,
's256ab831a48c941c': `Fjerner al tekstformatering fra markeringen`,
's2591806d7b222591': `Nulstil ændringer`,
's25e1a07e454c2c11': `Gitter`,
's262abbaf1d05f009': `Blødt lys`,
's266935f2447fcd98': `Over til venstre`,
's268ecd1cef45a9a8': `Er du sikker?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Lysere`,
's27076e66c5d483ba': `Lodret justering`,
's2712dc5641a33226': `Pakkeregistreringskonti er beregnet til udviklere og giver dig mulighed for at
          konfigurere en eller flere registreringer`,
's27cc88818cc46ff6': `Stabil`,
's281d957112b10f12': `Rediger dokumentets HTML direkte`,
's28b6246ce616a548': `Indsæt en kolonnegruppe i tabellen`,
's29a1c26521879b9f': `Skaler ned`,
's29acfd2778e8c377': `Skjul avanceret tekstformatering`,
's29b24c06315e9343': `Indsæt et input`,
's29eb103449472e3b': `Indsæt en overskrift (niveau 3)`,
's29ee7434494a0dfe': `Indsæt en overskrift (niveau 2)`,
's29f21c34494d614d': `Indsæt en overskrift (niveau 1)`,
's29fbfc3449557f72': `Indsæt en overskrift (niveau 6)`,
's29ff743449588131': `Indsæt en overskrift (niveau 5)`,
's2a031834495bcdb4': `Indsæt en overskrift (niveau 4)`,
's2a75c946ef4dcab7': `Diverse`,
's2b2ae20d26f78ac2': `Blok`,
's2b8f50c64be440f7': str`Vælg 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Bestil`,
's2bad2d24def4aa0b': `Linjeskift (CJK-sprog)`,
's2ceb11be2290bb1b': `Annuller`,
's2ced8e8fafb499f6': `Slet element`,
's2d986d31f8d67357': `Indsæt et feltsæt`,
's2d995a37cf5e4995': `Indsæt et NoScript`,
's2de969afacdaa7a6': `Form`,
's2df075aface0dab8': `Del`,
's2e192b19ed15fcf6': `Side`,
's2e39b99cf23606fa': `Indstil layoutet for de valgte elementer`,
's2e4818861000b13f': `Layout`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Overløb (y)`,
's2edd6688a65e21f0': `Overløb (x)`,
's2f0bcdffc92a786b': `Flyder til højre`,
's2f2044f2431a32d5': `Overskrift`,
's2f4d4bfbc466d91f': `Albansk`,
's2f8da2cb5f236588': `Navnet på din pakke. Skal være scoped, f.eks. \`@org/pkg\`. `,
's30cce87854901922': `Børnehave`,
's3124653c272f054c': `Kolonnens regelfarve`,
's314a4f7685c8e824': `Altid`,
's31c06e226322f065': `Undgå forældreløse børn`,
's323dcde72b850272': `Offentlig adgang`,
's32911e52ee8ac745': `Indsæt et slot`,
's337a1e9022a8d19f': `Bord`,
's33c1450d2822bb0f': `Indsæt en billedtekst`,
's33c18d5a4cbffa2a': `Irsk`,
's33f85f24c0f5f008': `Gem`,
's342b0cabfa672822': `Hjælp brugeren med at finde din widget`,
's3437e0d9899e7ae1': `Send telemetridata om din brug af WebWriter.`,
's344ea8f4939cdc98': `Farve`,
's34dcda3b0f9d5a98': `Skift url`,
's34f724979a124c50': `Indstiller baggrundsfarven for den valgte tekst`,
's355b21b89ce5d9c5': `Detaljer`,
's35ae5f4e0fa2777b': `Brugerdefineret justering`,
's35aeaff1425bca9e': `WebWriter understøtter ikke medier af typen `,
's35c3125c7750681e': `Blokcitat`,
's3643189d1abbb7f4': `Kode`,
's3649bacefe731bf6': `Skift værktøjskasse`,
's365280e16a8ea32d': `Kopier markeringen`,
's366991b9c9287765': `Til højre`,
's36a194e38d653a26': `Annotation af data`,
's36b3cefdcb897f15': `Perspektiv`,
's372fae706048ce41': `Lige-ulige`,
's377e24af9628c37e': `Bestilt liste`,
's37a8c35f6581da5f': `Intet anker`,
's37fa3b9cd51c2dfd': `Indstiller markeringens skriftstørrelse`,
's380d17664bb69531': `Indsæt kolonne før`,
's3815184eb09f0dcf': `Markør`,
's382a2aa3984474dd': `Opret`,
's38980f98cb07ceb8': `Gem det aktive dokument som en kopi`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Ruby-position`,
's3a5ca02f282d247e': `Del...`,
's3ae67088bbefba98': `Pakker`,
's3b0ab4b52326316f': `Lys`,
's3b3ea038c5d3bb06': `Division`,
's3bdad99768e11911': `Kan udforskes`,
's3cb47df8290fa94c': `Indsæt en mulighed`,
's3cf89cb47fdde7e9': `Link`,
's3d09398e555ee5f9': `Avancerede indstillinger`,
's3d249bb480032121': `Liste`,
's3d3efd1e19bdcfb4': `Dato/tid-annotation`,
's3d6a732c792ccb9e': `Ruby-annotation`,
's3d93f9ea0c5a13fa': `Billede`,
's3d9548e211b958ce': `Spring overlapninger over`,
's3e092e9d1ee2c5bb': `Klip`,
's3e78ddc9a48a608d': `Smuk`,
's3eb6d1e6e79ed7c4': `Ingen dokumenter fundet`,
's3eca5a034978754b': `Slet markeringen`,
's3f06e9abb6ebcb79': `Karakterer`,
's3f1e7a3f2b283d3b': `Margin`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Indsæt en artikel`,
's3fd83566dd643d10': `Indsæt en forklaring`,
's3fe72792941c18f9': `Tekst i bunden`,
's3ffcdc5db5e7d0c5': `Omvendt`,
's40e3826b7f74a3b5': `Pan (til højre)`,
's40f07d7859284a44': `Dominerende baseline`,
's4101ada154a1b958': `I midten`,
's410c465a5993f82d': `Mulighed for linjeskift`,
's41322d19c928c603': `IKT`,
's417b90913e05bc17': `Forhåndsvisning`,
's418f2020fe996832': `Bekræft ændringer`,
's41c724f0698148e9': `Marker markeringen som en tastaturgenvej`,
's41f65a763f8e44ab': `Gruppe af tabeloverskrifter`,
's42721130228841b0': `Boks til slagtilfælde`,
's429bd646f1cf8bc6': `Med Grammar LLM-konti kan du bruge Grammar LLM-API'en til at rette grammatik i tekst.`,
's429dd933ba95549b': `Indsæt en adresse`,
's42e470ef1d707a28': `Autoplay`,
's42ffdab1291fb3de': `Indsæt række efter`,
's430831017f3f0499': `Skævhed (y)`,
's430bd5017f42511c': `Skævhed (x)`,
's433ba70286202ceb': `Bryd alle`,
's441b20a8a50e36b4': `Makedonsk`,
's445b8acb9206db6e': `Kassér og annuller`,
's446a924922651ea0': `Fremhævelse af tekst`,
's44cdba92713de38e': `Gitterområde`,
's45518abd911471d0': `Kroatisk`,
's456a8d744313852a': `Plads omkring`,
's4634541f5056a546': `Abkhasisk`,
's46d4abe6255cb9e1': `Tildel genvej igen`,
's4730c232e7209c40': `Trim begge dele`,
's474f0eec369d02a4': `Eksempel på output`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Marker markeringen som en dato/tid-annotation`,
's47ebf3a8fb3b10c1': `Orientering`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Mulighed`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Skygge på tekst`,
's4993444bfd3f3e5e': `Kollaps`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maske`,
's49dd67aed00029ef': `Matematik`,
's49e763aed00877a8': `Vigtigste`,
's4a894f57eba1cf1e': `Tastaturgenvej`,
's4ac1ad6ecd6bd810': `Diverse udgaver.`,
's4ad6e9d3c2365c98': `Hårdt lys`,
's4b2c143acf931122': `Linjehøjde`,
's4b58c01e2578f5e4': `Legende`,
's4bbff4e008690da1': `Undgå side`,
's4c1535f316305a2a': `Undersøg udvælgelsen`,
's4c402ff5355fd310': `Tovejs overstyring`,
's4caed5b7a7e5d89b': `Engelsk`,
's4cb38675a21b2c98': `Ikke-understøttet egenskabstype '\${desc.type}' (behandles som JSON)`,
's4cc8391f172c0cdf': `Afslut turen`,
's4d528b416ac8dee2': `Indsæt en overskriftsgruppe`,
's4d546f6c87128d5b': `Rummet først`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Fejl ved tilslutning`,
's4e361bf8eef3759a': `Ordpause`,
's4ea0f21fc2a338a1': `Bevæg dig opad`,
's4eace13b3ed74187': `Kommentar fra siden`,
's4efee5b48a4593cb': `Sløjfe`,
's4f26e7cb7c0a8318': `Vektor-tegning`,
's4fd2e638aabb0bb3': `WebWriter understøtter indlejring af mange forskellige kilder. Du skal blot indsætte
          et link til indhold fra:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Tynd`,
's50489ffb1bde152e': `Indsættelse`,
's5068560b8d39663d': `Klikbart kort`,
's517acbf1f96324f9': `Vægt`,
's523eb9043213ff0d': `Kursiv`,
's52777d434baeed9b': `Indsæt en statusindikator`,
's52af5d7ac34c2163': `Tabelrække`,
's52e0bdc3ee304436': `Indsæt en måler`,
's531056f039febd39': `Indsæt en markering`,
's536695196d0b6dc3': `Færøsk`,
's542fcefa0bbaed86': `Åbn eller luk værktøjskassen (kun på smalle skærme, ellers er værktøjskassen altid synlig på siden).`,
's5432ad3c84273229': `Figur`,
's543906d1db8b2283': `Rediger `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Cambodjansk`,
's54897f2764b0e4d0': `Installer denne widget-pakke`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Marker valget som meget vigtigt`,
's55905c735052d295': `Tematisk pause`,
's5590dbf7e425789d': `Etiket`,
's5623aa2f83b05c76': `Tibetansk`,
's564d1648b1ceee9f': `Op til dato`,
's565cd5ffb0158c46': `Undgå område`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Gå tilbage`,
's5787c6d5b3b5541a': `Klip sti`,
's579c69f419b6caef': `Glat`,
's587ac858dd80f6fa': `Underskrift`,
's58bec0ecd4f3ccd4': `Streng`,
's59404f5593c32fdc': `Skriftens kantning`,
's5941292bb77281ab': `Norsk bokmål`,
's599dcd2472c75c19': `Paragraf`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Marker markeringen med en dataannotation`,
's5a356677b61a6b7e': `Moldavisk`,
's5b474b5c0ac0c7c4': `Gruppe af tabelkolonner`,
's5b517ac216f9ee62': `Sidelæns`,
's5b8cc9bb61ddce15': `Indsæt et afsnit`,
's5bba2ac2e53bd1fd': `Kirgisisk`,
's5be80ad6b8301710': `Inline-start`,
's5c1ecf88259b79f9': `Præsentation`,
's5c2a1a52c0389c30': `Ingeniørarbejde`,
's5c63af7695445fcf': `Tekst-stil`,
's5d18ca4c3111be6f': `Indsæt et tabelhoved`,
's5d87c1e588f48d90': `Øvelse`,
's5d929ff1619ac0c9': `Søg efter`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `Auto`,
's5e27738a2e8eb763': `Log ind`,
's5e2cba97c0d971bd': `Genindlæs pakker`,
's5e53415a6d5719ad': `Samfundsvidenskab`,
's5e6a7a0c30d2a270': `Spring overlapninger over (auto)`,
's5e9e8e4d21bafedc': `Produktion af fødevarer`,
's5ed03bb1f3a15949': `Billede`,
's5f43af3669b1e098': `Kilde`,
's5feaf7fd7ee567c8': `Bryd ord`,
's600fd23c9ce971e8': `Udskriv det aktive dokument`,
's602bbd28dae2c60f': `Start selv`,
's60ff598dfcf2c773': `Under højre`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Tabel Kolonne`,
's6196153c4b0c1ea0': `Installer`,
's61c017f6d5c303af': `Frisisk`,
's61ded17ca3f48c82': `Forskydning af understregning`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Valg af kopi`,
's624e31cd4f1b89d4': `Jævn scrollning`,
's626daf42b1ab7df7': `Juster til venstre`,
's6280bf993915c57a': `Rullemargen`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Beskrivelse`,
's63dfc5b1c1c27849': `Jiddisch`,
's63e03c70f67ebf9c': `Sammenhæng`,
's63e71d20d1eaca93': `Tysk`,
's640bc7710d0143ce': `Gør den sidst fortrykte ændring i det aktive dokument om`,
's64dc1fc7e3db45c9': `Opret et nyt dokument`,
's65ac276544ba33cd': `SVG-fil`,
's66765c420ee578e4': `Jævnt fordelt plads`,
's669b18c6d2d9c95b': `Ingen`,
's6747dbf4ad6063ba': `Selvstændig ende`,
's6787497df07fa97e': `Kan rulle over stop`,
's67c2b60a506a09e4': `Sekundær udgave.`,
's680bd4d926cd5a84': `Bevar 3D`,
's6827930ef1aeaf99': `Basis-URL`,
's684a16f3c711394d': `Over højre`,
's687e27f036a71b32': `Isolere`,
's68b87d7b61052dc3': `Tabelrække`,
's68e0e3a2bab7ce3e': `Undgå at`,
's690da6b432987c6f': `Sikkerhedskopierer automatisk ændringer i det aktuelle dokument. Ændringerne gendannes, når WebWriter genindlæses.`,
's69311c4e25074fb3': `Gymnasiet`,
's697400b541fbc3cd': `Under`,
's6988ab5d47593a26': `Du har den nyeste version af WebWriter.`,
's69a49786a8009f43': `Find pakker...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Omslag`,
's69fbbdb8ad2a084a': `Mørkner`,
's6a31eff1ec4f71ad': `Skjul bagansigt (3D)`,
's6ac62e1c8c66f3bb': `Kompakt superscr.`,
's6b585ba37cdb8260': `Arve`,
's6b61f8abf89586be': `Hebraisk`,
's6bd7a02fdf93e653': `Juster indholdet`,
's6cfc66b824ea05ba': `Skarpe kanter`,
's6d02dc19e21eb49c': `Til toppen`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamesisk`,
's6d8b3b8047ed378d': `Blandingstilstand`,
's6d8c02aee480af7a': `Menu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Indsæt en stil`,
's6e288a119281f4c2': `Gengivelse af tekst`,
's6e4c20c6debcd5ca': `Brugerdefineret begrundelse`,
's6f84199e62584905': `Præformateret tekst`,
's6fb3053e7244d326': `Andre områder`,
's70178e04a3b691b6': `Åbn indstillinger`,
's7031ca562378bde6': `Geometrisk præcision`,
's7060970b5ed20a58': `Interaktivitet`,
's7136449045eff28c': `Tamilsk`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Vis ustabile pakker`,
's71dec51005acc1e4': `Række tæt`,
's72f2a02e2a5a4ee3': `Medier`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `Denne enhed`,
's736904f276fbd441': `Naturvidenskab`,
's739544d0c858c633': str`Eller aflever 
          ${0} her 
        `,
's73cb20c838e761e1': `Valg af snit`,
's7417792bbe720149': `Gør det om`,
's741fae02b3dd24f3': `Pixeleret`,
's743f778233e42a3f': `Indsæt en sidebemærkning`,
's744d993d03f29851': `Skærm`,
's748c0074eff45884': `Manipulation`,
's74aa0039a87141e2': `Ellipse`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Udfyld boksen`,
's75109f5307578a61': `Velkommen til WebWriter`,
's75a27f43413e02c5': `Fransk`,
's75d83fc3f0cfab40': `Overskrift`,
's762e5704cc84089d': `Indstil andre stilindstillinger for valgte elementer`,
's77318393dfdb0775': `Fjern række`,
's77e594ddcc10c774': `Tillade kommerciel brug?`,
's782eac2b3e80323d': `Marker markeringen som fremhævet`,
's782f286a79cca35d': `Relativ`,
's78673a3539cb1915': `Øverst til venstre`,
's78789724e789221c': `Størrelse`,
's789ff24c8f03f1a4': `Afstand mellem bogstaver`,
's7995733bf97c01cc': `Serbokroatisk`,
's7a99528e7b64635a': `Occitansk`,
's7aaf0c06e69600f1': `Fejl med `,
's7ae49e142487766c': `Adgang til fællesskabet`,
's7af555180b30a947': `Åbn udviklerværktøjerne`,
's7b4ba250601b8667': `Indsæt en skabelon`,
's7b560d8693ed8f42': `Opretstående`,
's7b9994904c4f5b54': `Tadsjikisk`,
's7bdf0fd5b014d36c': `Stor betydning`,
's7beb1e77e82363eb': `Fortryd den sidste ændring i det aktive dokument`,
's7c61118554a0ec36': `Maksimum (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Virksomhed`,
's7cfe12cd14df9950': `Meld dig ud`,
's7d27db3c9639c6dd': `Alternativ`,
's7d8103f6f06f83d6': `Polstring`,
's7d864465dddbb50d': `Tillad ændring af størrelse`,
's7de0e28d6c309a4e': `Tillad berøringshandlinger`,
's7dea785045c3cc74': `Tryk på en ny tastekombination...`,
's7e0b179d4d1414eb': `Indtast link`,
's7e6570f2f1ae320f': `Syntetiser skrifttyper`,
's7ecb1f29332293e5': `Baseline for tilpasning`,
's7ed13ccddb1bf3c3': `Overlay`,
's7edbe0b213199995': `Bachelor`,
's7ede1c55e35ce9d6': `Simulering`,
's7f09197a4814079b': `Indstil interaktivitetsmuligheder for udvalgte elementer`,
's7f326a142e856656': `Stil`,
's7fcb35d23be1e643': `Feltsæt`,
's80570196a9ce6d11': `Aktivér telemetri`,
's806f84eb0ace116e': `Se, hvad du har valgt, og ændr det. Kopier, klip, indsæt, fastgør eller lav layoutændringer. Tilbyder forskellige muligheder afhængigt af dit valg, f.eks. formatering af tekst.`,
's80a42b81c52d4d8f': `Caret-farve`,
's80b71fc6f43c5ce1': `Løs`,
's812cbda653daaeba': `Denne funktion er ikke implementeret endnu`,
's814d528c8af55807': `Definition af listeelement`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Fortsæt`,
's8247d32213e35f24': `Indsæt en main`,
's82665b2ffabc9c0a': `Hjemmeside`,
's828b1ecea8715884': `Pan (venstre)`,
's833bd0422a7ef95d': `Fanen størrelse`,
's83420ad7b6a14db5': `Skift mellem udviklingsværktøjer`,
's83c15613b6f6f3c8': `Kun online`,
's83cd32b685ccc9b7': `Kontroller`,
's83f26d02dd7aa681': `Synlig`,
's840fa49e8989c028': `Position/form`,
's844a76d1843ceb3c': `Nulstil til standard`,
's84e4e8ae645b82ac': `Øverst til højre (y)`,
's84e9c7f8785ca60b': `Indsæt en formular`,
's8517ae4da104b004': `Gruppe af tabelkolonner`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licens som Creative Commons OER?`,
's85f9aa6d3ea0e421': `Gruppe af bordfødder`,
's864b0e6270e97246': `Marker valget som en sidekommentar`,
's8670e5ad3bf0dcf8': `Gem som`,
's8688d74dd3716d6e': `Tastaturgenveje til kommandoer`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Form-margin`,
's87cefc710b3567fb': `Indeholder`,
's88676f992b2965db': `Stræk cellens indhold`,
's886897f2fd4edb99': `Skjult`,
's886c5db2a5579873': `Koncept`,
's888c71e8fcb916d3': `Automatisk lagring`,
's88a62d29529948fb': `Indsæt en tabel`,
's89950d86c8004d4b': `Spring ingen overlapninger over`,
's89bca7498f20e041': `Baggrundsklip`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pause før`,
's8a4ff2bd9c13498c': `Rekord`,
's8a6585c48ea104e9': `Skjul tomme celler`,
's8a9eb438abac7c6a': `Etiketter`,
's8b0432eecbd8b034': `Opdatering`,
's8b7580c35e2aef87': `Øverst til venstre (y)`,
's8bc4affa761aa8a2': `Indsæt et billede`,
's8c7f51cb067644c7': `Dataliste`,
's8d342ecaa9e75b9b': `Relation`,
's8d797888455f4147': `Pauserum`,
's8d83386457e91813': `Fortryd/genopret dine ændringer eller se en forhåndsvisning fra elevens perspektiv.`,
's8d8643013a7754d1': `Juster tekst`,
's8df30fe2a50d3479': `Indsæt en mulighed for linjeskift`,
's8e715248c3a78446': `Klip udvalget ud`,
's8f29e48d6b9a1aa8': `Indsæt en række med tabeloverskrift`,
's8f4be9f086eb530f': `Fortryd`,
's8f533296a536965e': `Gem som...`,
's8fad58c831ecf017': `Ruby-tekstbeholder`,
's8ffe7abcbed8eb43': `Lodret, fra venstre mod højre`,
's90105521fcc40453': `WebWriter Cloud-konti giver dig mulighed for at gemme dokumenter online og dele dem
          med dine studerende. Tilføj en konto her, og den vil være tilgængelig som et sted, hvor du
          kan gemme, indlæse, dele og åbne dokumenter.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Skrifttype-palet`,
's90f7c1cf501ea0a7': `Farvelægning`,
's91093e0b087911ba': `Fremhævelse af position`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Indsæt indlejring`,
's9219acd5bef6269e': `Under venstre`,
's92548405912d46bf': `Scroll snap align (y)`,
's9258280591309342': `Scroll snap align (x)`,
's927d796559f49439': `Baggrund Oprindelse`,
's92b177e579ef7b97': `Fremhævelse`,
's92f846b9be2e8e8d': `Marker markeringen som kursiv`,
's93566b84230af4f5': `Indsæt et billede`,
's936aa0b239679585': `Indsæt et tematisk brud (vises normalt som en vandret linje)`,
's9370dc6afa716b57': `Grænse`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Defineret periode`,
's9485af2e7cd9418f': `Grundskole`,
's94d2eee44b292567': `Skift mellem avancerede indstillinger`,
's94d61907ee22a8c1': `Koreansk`,
's94eb1effbbb6498b': `Overløb`,
's951aa3a6439f1271': `Liste over markører`,
's9565553d163fc92a': `Manuskript`,
's957787fc6b7ea5c0': `Pan (op)`,
's95c161f68e5180a5': `Inspicér udvalg`,
's95d56e58f816d211': `Hollandsk`,
's95d8e41a64635c7c': `Hvid plads`,
's95de7e1eff6c053e': `Vandret, fra top til bund`,
's960d3a90ac199368': `Retorisk-rumænsk`,
's96532132a29dd542': `Indsæt lyd`,
's96a045dcade75ad0': `Søjle tæt`,
's9781a5bb3fcb26a3': `Vælg en virksomhed først`,
's978522fbc9577a7e': `Somali`,
's97881699a2b21d5b': `Rækkeafstand`,
's97aa76056a81bd36': `Metrikker`,
's986facb3ecc9602c': `Sidelæns, fra højre mod venstre`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Ekstern fil`,
's98977a87d1b93941': `Nulstil information, stilarter og scripts`,
's990d0e0fa2ab00b5': `Galicisk`,
's99229574e5692f19': `Grønlandsk`,
's99a990f3841ad283': `Filer af `,
's99b38e000175cc84': `Gennemstreget`,
's99f110d27e30b289': `Titel`,
's9ab10fbf4c7a7322': `Understregningsposition`,
's9abadcc828884d7b': `Tekstområde`,
's9b7cd8860c8fc922': str`
          ${0}
          vil blive overskrevet. Er du sikker på det? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Baggrundsfarve`,
's9c8df9626d152d5a': `Definition liste udtryk`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Tabelkolonne`,
's9cf68f87b8e6122f': `Aserbajdsjansk`,
's9d167ef77aed79b6': `Lag`,
's9d2d00982edafabb': `Tyrkisk`,
's9d430adc5be110e9': `Række baglæns`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Sletning`,
's9df571714a1efb44': `En automatisk gemt version af denne explorable er tilgængelig. Vil du indlæse den?`,
's9e28faa598332e2b': `Indsæt video`,
's9e3dbb678150edd4': `Indstil skrifttypefamilie`,
's9e40e59654c8ad67': `Søjle`,
's9e85800d3700e31c': `Spor`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Skrifttype-variant`,
's9f1ecdb3061d9cbc': `Bevar rummene`,
's9faf26107ed49fb9': `Indsæt en tabelcelle`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Overgang`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Lærred`,
'sa00df4e39c72d3b4': str`
          ${0} er ikke understøttet 
        `,
'sa013e119fec906fb': `Række`,
'sa01e7bf33563ef72': `Baggrundsvedhæftning`,
'sa126cf8c627cec1e': `Rendering af billeder`,
'sa13f72278add7513': `Under højre`,
'sa1647e3b36ec08d7': `Kombiner opretstående`,
'sa172190ea21f9b1c': `Få adgang til indstillingerne, åbn en udforskningsmulighed eller opret en ny.`,
'sa1c6c459b9b5115c': `Absolut`,
'sa2cba871f6cdd99f': `Assamesisk`,
'sa2eff4dad1c119f1': `Gitterskabelon`,
'sa30c12014e955946': `Russer`,
'sa30f1981fd1cd441': `Skriftstørrelse`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Indsæt en sidefod`,
'sa37fee6a52d18063': `Slet dokument`,
'sa39c7ac1d37f3bce': `Marker markeringen som et 'tovejsisolat'`,
'sa3b4c01623211544': `Kraft`,
'sa40fd43756fa8913': `Persisk`,
'sa417644bef21a9aa': `Ikke navngivet tema`,
'sa43800e28be1bdbc': `Dekorationsfarve`,
'sa477cb1825dceb3b': `Sudanesisk`,
'sa492a51a707930fa': `Indsæt et blokcitat`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Billedtekst i bunden`,
'sa50d3c35533f1d99': `Alle felter`,
'sa53c5cb03a8fda50': `Fastgør markeringen som et uddrag i paletten`,
'sa557ae6bee9148a6': `Fremskridt`,
'sa589e1df65dde0ec': `Indstil størrelse, udfyldning og margener for de valgte elementer`,
'sa5c371b4bb75e590': `Til venstre`,
'sa5c80e623459ffe4': `Indsæt en overskrift`,
'sa5df1bcdba46c3fb': `Billedtekst`,
'sa602e3fd3f2d98fd': `Animation`,
'sa644d580d8a11e60': `Ruby-tilpasning`,
'sa645d315510dc09e': `Vælg sti fra disk`,
'sa65d4ad99f1d8c06': `Indstil tekstens baggrund`,
'sa6607436f60ccc1a': `Estisk`,
'sa6f8d27bca557059': `Flyt meta/link/style-elementer op/ned i dette element`,
'sa757645ad842da97': `Bevar pauserne`,
'sa75b95980cd80e78': `Redaktør`,
'sa7698b3d20a6d1ec': `Rulle`,
'sa778acc33947c7b8': `Afslut turen`,
'sa78a67272a4a6f95': `Matematisk formel`,
'sa79167651dce1e80': `Alternativ tekst`,
'sa7af797a46c7d09a': `Foden af tabellen`,
'sa7dbe35b758c138d': `Indsæt et lærred`,
'sa7dc6b8ef3f595dc': `Indsæt en kilde`,
'sa8279f8211b3950d': `Bevar pauser og mellemrum`,
'sa8b55cab62e439b5': `Fjern kolonne`,
'sa8bbe0197d31b423': `Kort beskrivelse`,
'sa9ff3b762365abe6': `Transformér oprindelse (z)`,
'saa02e3762368ff35': `Transformér oprindelse (y)`,
'saa065776236bfa28': `Transformér oprindelse (x)`,
'saa33768e03c45fc8': `Filstørrelse`,
'saaad98061a20ac39': `Indsæt en matematisk formel`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Skift over`,
'saaec15c97a9e4245': `Kolonne baglæns`,
'sab0c57df694a0a09': `Trim start`,
'sab4d9283896d9422': `Snap-opløsningspixels`,
'sab55faae8e165407': `Udfyldning&lt;br&gt; som mellemrum`,
'sab5e7d2a069a2951': `Erhvervsuddannelsescertifikat.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Juster til højre`,
'sac895c732f350ac5': `Mørk`,
'saced41ddda8b2354': `Flex basis`,
'sad190f86451081c0': `Nepali`,
'sad6be321164d08c8': `Kompakt matematik`,
'sadd352cc7f6f2307': `Til side`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Svensk`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Indsæt en beskrivelsesliste (ordliste, termliste)`,
'saf3da7c95cb17260': `Marker markeringen som en overskrift`,
'saf440a0a592f2835': `Opdatering til`,
'saf9e5134ba1a7d30': `Scroll snap`,
'safc6f203342d09e2': `Skifter til forhåndsvisning af det aktive dokument`,
'sb0a7e3adf4a125ee': `Øverst til højre`,
'sb0a974028c99ca6d': `Tillade tilpasninger?`,
'sb0d4f0f7993cf085': `Indstil skriftstørrelse`,
'sb0f3327210fe18fc': `Søjler`,
'sb0f93c1c60c0249a': `Ruby base`,
'sb1494c08c8c720d1': `Indstil tekstfarve`,
'sb19611adbc88f711': `Avanceret: Vis kilde-redigeringskommandoer, f.eks. for at vise dokumentets HTML eller for at tilføje brugerdefinerede stilarter og scripts.`,
'sb206d700d26b14ff': `Understregning`,
'sb233557012dcb328': `Bevæg dig nedad`,
'sb26035b596566abf': `Ikke navngivet`,
'sb2cda80610c8d6ea': `Plads til alle`,
'sb2dc787b0983ebc6': `Litauisk`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Center`,
'sb3ba3276ae93627c': `Indsæt en præformateret tekstblok`,
'sb430f5b4824de0d3': `Vælg et layout`,
'sb43db07b24da018a': `Amharisk`,
'sb45f9fb4dba6e71a': `Ikke indstillet`,
'sb4e003a459464d85': `Kurdisk`,
'sb4f0310e6787d098': `Usbekisk`,
'sb4f1dffbb6be6302': `Klar`,
'sb51270e19988f9bd': `Region`,
'sb59d621e3c93cc27': `Delte cellegrænser`,
'sb5e9e1776242b028': `Interaktioner`,
'sb60bc1250aad44c1': `Spændvidde`,
'sb60dd9d23d31ee66': `Doktorgrad`,
'sb6103872073d369e': `Indsæt detaljer`,
'sb616811735bfbafd': `Tabelcelle`,
'sb628960829e223bb': `Spring alle overlapninger over`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Ansøg og importer`,
'sb66e2181a7b5738a': `Ved at aktivere telemetri giver du tilladelse til dataindsamling og -opbevaring i henhold til vores`,
'sb67e0e7c0869f982': `Forskel`,
'sb68e83cda6c85af8': `Tabeloverskrift`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Dekorationens tykkelse`,
'sb70c17f7899f9b01': `Latin`,
'sb71941f552f3504d': `Indstil særlig værdi`,
'sb740eab4afd5a710': `Automatisk flow i nettet`,
'sb741b6e0ca589122': `Vend tilbage til laget`,
'sb7fb7568f6883ab8': `Del det aktive dokument`,
'sb85774dc5d18ff0f': `Bekræft`,
'sb85b1e36579852a6': `Ugyldig e-mail eller adgangskode`,
'sb884fa76bfc55429': `Arabisk`,
'sb8a3d4df7d1c5e6b': `Balance`,
'sb8f610a0e8df91fc': `Lysstyrke`,
'sb8f855b49234b81b': `Ansøg`,
'sb905da066c10182c': `Plus mørkere`,
'sb940ade1bd81be7e': `Under venstre side`,
'sb9e9a7dd45966756': `Marker markeringen som fed`,
'sba509fd8ed61d1d5': `Ikke gemt fil`,
'sba64d8954d027206': `Opacitet`,
'sba88d90cd6c751b3': `Kolonneregel`,
'sbaf0a7c417e388af': `Sundhed`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Baggrundsfilter`,
'sbb85a407d730e13d': `Indsæt en søgning`,
'sbb86c6c96f598bb8': `Blandet`,
'sbba0156f795d8c07': `Rediger valg`,
'sbba865d4b437944f': `Attribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Afinstaller`,
'sbc5f2a81604baf9b': `Rubrik 6`,
'sbc5f2b81604bb14e': `Overskrift 5`,
'sbc5f2c81604bb301': `Overskrift 4`,
'sbc5f2d81604bb4b4': `Overskrift 3`,
'sbc5f2e81604bb667': `Overskrift 2`,
'sbc6953a36ced943f': `Privatlivspolitik`,
'sbd181cd54b8402a4': `Rediger valget`,
'sbd35ee879d9cf770': `Ruby-tekst`,
'sbd40f40cbadd38d5': `Fjern denne widget-pakke`,
'sbd72dc858de95ce8': `Burmesisk`,
'sbe3c60c65f129daa': `Humaniora`,
'sbe4a7c8f231739b3': `eller indsæt/drop/vælg fil`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Indsæt et linjeskift`,
'sbf00e1ee999ea94e': `Indsæt et script`,
'sbf519920c2017d67': `Hængende`,
'sbfa01f189a68d3e9': `Flex vokser`,
'sbff54e740c4086eb': `Vis ukendte pakker`,
'sbfff51feacf30196': `Sanskrit`,
'sc0ceaa9843510f67': `Turkmener`,
'sc1611c0558728a2a': `Position`,
'sc1a155cc25899250': `Gruppe af tabelrækker`,
'sc1aa1f6051b7102a': `Rumænsk`,
'sc1edebeaef92b7bd': `Fast tabel-layout`,
'sc1fff4f356dfb2fb': `Transformere`,
'sc24bda3c061fddf8': `Klikbart område`,
'sc252a4e091763606': `Indsæt en sidefod til en tabel`,
'sc2536e077514accc': `Rulning`,
'sc275dd00036d16cb': `Citater karakter`,
'sc28864200d2a3799': `Kopier QR-koden som billede`,
'sc2a24a9dd41a9503': `Dekorationslinje`,
'sc2b734cca2fa643b': `Pan (ned)`,
'sc2e2a0dbf03723b7': `Avanceret: Vis pakker fra ukendte kilder i pakkehåndteringen (Advarsel: Kan være usikkert)`,
'sc3998b77d72c2932': `Indsæt en hjemmeside (som en inline-ramme)`,
'sc3ac225273c8316b': `Generelt`,
'sc3cfee84dbbf36ae': `Lokal fil`,
'sc3f09a9b6fa4fbed': `Indenfor`,
'sc43767deea72e9f3': `Beskrivelse Liste`,
'sc462bbdd36bcba6b': `Referenceboks`,
'sc4ee3e4ee994dafd': `Ukrainsk`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Perspektivets oprindelse (y)`,
'sc52e8b794c0913d6': `Perspektivets oprindelse (x)`,
'sc53de149fcaad713': `Mellem karaktererne`,
'sc5bcf50d1b578d9f': `Indstillinger for skrifttypefunktion`,
'sc5cb39478b9b7625': `Marker markeringen som en underskrift`,
'sc6415b50ff928294': `Liste over emner`,
'sc650ff15b20fe9d3': `Drej (z)`,
'sc6578b15b2154365': `Drej (x)`,
'sc65aff15b2183e58': `Roter (y)`,
'sc6da0f4a7e4d710e': `Overstyring af skriftsprog`,
'sc74e3567875ce255': `Både tagget på din widget og navnet på din NPM-pakke`,
'sc7eb080b96e244df': `Malay`,
'sc8ac7ef92b95df3f': `Flyt (x)`,
'sc8af536e2084ade0': `Palette`,
'sc8b022f92b992bc2': `Flyt (y)`,
'sc8b39af92b9c2d81': `Flyt (z)`,
'sc8d2c7f6c33a2b32': `Indstil tekststil (justering, indrykning, afstand osv.) for udvalgte elementer`,
'sc8fa0e3de389ef1c': `Justering af skriftstørrelse`,
'sc9474bf7a0668d73': `Sammenfatning`,
'sc94e314312a8900c': `Tjekkisk`,
'sc980855a000b76ea': `I bunden`,
'sc98b103772de63f4': `Finsk`,
'sca7cfe2bef51b2a5': `Rod`,
'sca7fed2bef53cb99': `Rolle`,
'scabe6ecee5e01fd2': `Maltesisk`,
'scace301a88231cce': `Indlejre`,
'scbc55f622ec078c1': `Vis boks`,
'scbe537fc38ff4c13': `Automatiske kolonner i gitteret`,
'scc1db59d292cbc4c': `Sektion`,
'scc56b218a2689c42': `Armensk`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Boks til polstring`,
'scd9cedeb5ece3adb': `Bindestreg`,
'scdf536b65be39ec5': ` Opret/importer`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografisk`,
'sceecdd0bb404bc17': `Indsæt en indstillingsgruppe`,
'scf00d48fd5953a03': `Græsk`,
'scf932840a69dbb7c': `Portugisisk`,
'scf932a8577057752': `Sidefod`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Nederst til højre`,
'sd01178c54f648118': `Balance-kolonner`,
'sd03bff50f87f82d4': `Tegn med bindestreg`,
'sd05a155fe09c2866': `Online, når du bruger`,
'sd0864ea6cb6ef22e': `Fællesskabet`,
'sd10fdbe6caf9a998': `Linjeskift`,
'sd121d3b959b7888d': `Optimer hastigheden`,
'sd1a78e667a1a139f': `Marker markeringen som en indsættelse`,
'sd1cffad290ea5b3b': `Behold alle`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `E-mail`,
'sd1f81984eeb7c0e8': `Fyld`,
'sd29dc07235eea0f5': `Citat`,
'sd2addf69477cd4b4': `Importer pakke`,
'sd2ed26defc646d47': `Baggrundsfilter`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fast`,
'sd3a288c1094b8a63': `Kolonnens regelbredde`,
'sd3c65ef5c380c046': `Indsat`,
'sd3dcb76f7b28adb8': `Lettisk`,
'sd3eca1e0f4209f6e': `Trim alle`,
'sd3f402df8619ddcd': `Disse oplysninger om dig tilføjes automatisk til nye dokumenter. Du kan ændre dette
          for hvert dokument i metadataeditoren.`,
'sd4368b12645d3c0f': `Indsæt en portal`,
'sd452cebf4a0313d1': `Vis kommandoer til redigering af kilde`,
'sd48cc52117f4d68b': `Italiensk`,
'sd52660ee947ca58b': `Indsæt en tabelkolonne`,
'sd588d17a1b25c220': `Overløb af tekst`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Højere uddannelse.`,
'sd5cf95145e4d89ca': `Frigiv dette uddrag`,
'sd5fd9d11a92f5b1d': `Nederst til venstre (y)`,
'sd60c9bbc51375635': `Indsæt en knap`,
'sd66c4767fa3dde28': `Accentuerende farve`,
'sd679c8b1bf8cc8a5': `Små selskaber`,
'sd7086c4425c53c80': `Skrifttypefamilie`,
'sd837f42ac7cbfb58': `Form (udvendig)`,
'sd88076d2994ee0fb': `Udelukkelse`,
'sd89a2e529b31ef43': `Vend tilbage`,
'sd8a345e95668b73b': `Lodret, fra højre til venstre`,
'sd8ce9e57270b030d': `Strækning af skrifttype`,
'sd8ecf227c7c49331': `Matematisk`,
'sd8f923198e0c5c6a': `Slut`,
'sd9c21e5f60d6bdd8': `Dansk`,
'sd9ff8e2612e63d50': `Størrelse på kantboks`,
'sda2d76b976502a8d': `Åben...`,
'sda344aacb837387e': `Position i container`,
'sda5b6fa8b771f996': `Flyder til venstre`,
'sda9254d1f1228e1a': `Ungarsk`,
'sdb1595f5c742dfbb': `Input`,
'sdb711380a28fec75': `Indsæt en liste (ordnet)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Nederst til højre (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `Georgisk`,
'sdd1ff479d04ac140': `Offentlig`,
'sdd2fc8919a9c3111': `Baggrundsblandingstilstand`,
'sdd35b688281b6dea': `Japansk`,
'sddc49047f66a64ab': `Ingen beskrivelse givet`,
'sdef34fe08bb28b09': `Kinesisk (forenklet)`,
'sdf62e305e1594805': `Marker markeringen med en ruby-annotation`,
'sdf946172dfa0328f': `Overskrift`,
'sdf9bc5d9b7f3e3de': `Tilpasning`,
'se036b53f145441cd': `Blandet indhold`,
'se06f459fccdc3ce9': `Juster sidste tekstlinje`,
'se0a782a8be8e018b': `Norsk`,
'se0cda6b80a1bb50f': `Slovakisk`,
'se0f67eae944f8f94': `Dæmpet`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artikel`,
'se1f5bb0386c88f96': `Indstiller farven på den valgte tekst`,
'se219da7b1e955c65': `Tydelig formatering`,
'se25e4f2cb77b8be8': `Sprog til WebWriter-grænsefladen og nye dokumenter`,
'se2796c5824ec8916': `Synlighed af indhold`,
'se308836a594808b6': `Singhalesisk`,
'se36c5b1baf5e0660': `Hvor som helst`,
'se39c065efa467782': `Baskisk`,
'se3b4c857f91f80d7': `Tastaturgenveje`,
'se47baf2fd16b9d2b': `Skabelon`,
'se48bd9e6c2a3109d': `Regnskaber`,
'se58467472725ad0c': `Billedopløsning`,
'se58f06c2b0583ff7': `Vælg koordinater`,
'se5dc1e97fb743ade': `Afstand`,
'se619a501d1bfe6a5': `Indpakning`,
'se62385ac082368d2': `Marker valget som en kilde til citat`,
'se6297163cac9d276': `Rediger kilde`,
'se633223a0b88625e': `Placering af celler`,
'se638417c560cfe5c': `Bryd ind`,
'se64f418b4e733b6c': `Indsæt et output`,
'se6cdad455e2d8c02': `Indsæt en opdeling`,
'se79c0a3ac70d8fb3': `Asp. forhold (x)`,
'se79fae3ac710dc36': `Asp. forhold (y)`,
'se7fad370d8fb4cec': `Optimer læsbarheden`,
'se8a94b4effa2033e': `Alfabetisk`,
'se95d4e55ea186d9a': `Rullefeltets farve`,
'se96d43a515b8451c': `Slovensk`,
'se96fd76ba1b2975a': `Central`,
'se9ac05f36b004eb0': `Skjul den indledende rundvisning. Deaktiver, så rundvisningen vises igen.`,
'se9b1fec72ffd8f48': `Lokal`,
'sea24bdcaa2bd2dec': `Obligatorisk snap`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Slår metadata-editoren til`,
'sea896ed51ad33287': `Ingen specifikke stilarter tilgængelige`,
'seaaaeb09e3b4e78b': `Kommandoer til redigering`,
'seabae79729c4b2ad': `Skift e-mail`,
'seaecc8267bad6234': `Mellemskole`,
'seaf97719986faf4f': `Mellemrum`,
'seb19675a580f0628': `Undgå kolonne`,
'seb4e52ef5ec7a7dc': `Farver/effekter`,
'seb8982ae8c3cdcc5': `Indonesisk`,
'sebbced89e0db2894': `Første baseline`,
'sec02109a0dd2a6c8': `Fremhævelse af farve`,
'sec2557a35b702525': `Variabel`,
'sec2da4aa7a02b925': `Islandsk`,
'sec30fbb20f102670': `Indsæt resumé`,
'sec8b0b6c729816b6': `Overskriftsgruppe`,
'seccd05955adb76bc': `Plakat`,
'sed17285cd25d6389': `Katalog, hvor package.json er placeret`,
'sed318ec045c5144f': `Over`,
'sed713f1b916fb469': `Afstand mellem kanter (x)`,
'sed74a31b9172942c': `Afstand mellem kanter (y)`,
'sed86bd0deb2e5372': `Transformér tekst`,
'see2fcaedf9743ec6': `Beliggenhed`,
'seec6798afe90ffc8': `Print`,
'sef00c258bc1ecf1e': `Denne explorable har ikke gemte ændringer.`,
'sef23dd271edd4a8b': `Nederst til venstre`,
'sef24caccbd4645ef': `Flex-krympning`,
'sef49aec68fd1dc66': `Navn`,
'sef73fe18e351eb35': `Nøgleord`,
'sef75f458d77491af': `Tilvalgsgruppe`,
'sefcf950b3cc4fc3b': `Sprog`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Indhold`,
'sf0cab2483f66aa2e': `Brugerdefineret`,
'sf0e261e04eda82ff': `Udseende`,
'sf1045382c1fd9a85': `Præcise printfarver`,
'sf14c35392ec7bf10': `Denne funktion er ikke tilgængelig i Firefox. Den er tilgængelig i Chrome eller Edge.`,
'sf14f9d5f9f6ca342': `Plus lettere`,
'sf1868dc19e3917bb': `Spansk`,
'sf190149f9d8bbb2a': `Skrivetilstand`,
'sf1e79171c4856543': `Er du sikker på det? Denne handling kan ikke omgøres, alle dine indstillinger
          slettes og nulstilles.`,
'sf21c1f60c7515f44': `Marker valget som prøveoutput`,
'sf21fb4f4b9e8911f': `Bredde`,
'sf22a3737146ec910': `WebWriter kan indlejre SVG direkte i dokumentet.`,
'sf2514d5dc78b1654': `Indsæt widget`,
'sf28903d4ca0ddcfc': `Fjern denne konto`,
'sf2ab37af0abc55ef': `Skjul intro-tur`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf2cbb5e519264e67': `Ændr størrelsen både vandret og lodret`,
'sf2d5cbc2fe0ad65a': `Klistret`,
'sf2d96d0eb32cb81f': `Komposition af animation`,
'sf2de3dbe2108637a': `Rendering af form`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Indsæt et spor`,
'sf3c4da68b08a2590': `Malagasy`,
'sf471ec2496f904cc': `Kassér ændringer`,
'sf4849bc200e279ed': `Billedtekst til tabel`,
'sf486ca1fdbe08645': `Indsæt en figur`,
'sf4b537d4cbd8f5fd': `Tekst øverst`,
'sf4e0e02a5277ef23': `Indsæt et tekstområde`,
'sf4f067d41efd4b83': `Skala (y)`,
'sf4f3cbd41f002b46': `Skala (x)`,
'sf4fa67d41f05a008': `Skala (z)`,
'sf5197db2d5f2926a': `Drej`,
'sf52d840949a980d1': str`
          ${0}
          vil blive slettet permanent. Er du sikker på det? 
        `,
'sf55d634dcc743595': `Serviceydelser`,
'sf59c9081d106dd9c': `Marker valget som en variabel`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Slet et dokument`,
'sf65df67a03bebe4b': `Påkrævet for denne widget`,
'sf6673729c03ae999': `Nulstil WebWriter`,
'sf67571992e7dc88e': `Fuld periode`,
'sf6b4934598f7ed10': `Tillad valg`,
'sf6e1665c7022a1f8': `Adgangskode`,
'sf79e0d78b56444f1': `Inline-ende`,
'sf7a5f7a7c80c3082': `Begge dele`,
'sf7c0eba7c822e3d6': `Fed skrift`,
'sf86bd4d2982f3b74': `Marker valget som kode`,
'sf8e82313fa411494': `Marker markeringen som et link`,
'sf955eff73fb6b573': `Serbisk`,
'sf9929e2d356260c5': `Multiplicer`,
'sf993bb199fefbe04': `Alle`,
'sf9ecf969dd4b8164': `Begge kanter`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Privat adgang`,
'sfa59c7777e2a0eeb': `Indsæt en dataliste`,
'sfaa0a67db5c11f72': `Indrykning af første tekstlinje`,
'sfb231a52211b133f': `Ingen ombrydning af tekst`,
'sfb68cae41d749423': `Indledende`,
'sfb9b6edb0ed378c9': `Kilde til citat`,
'sfbbab09dbe553571': `Indsæt en vektortegning (SVG)`,
'sfc00292e778b67e2': `Meter`,
'sfc63e31ac7c956ed': `Vælg`,
'sfc815c9078bba30a': `Download QR-kode som billede`,
'sfcdd8e672c75b713': `Adresse`,
'sfcebd18506f1e535': `Flow`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Output`,
'sfdb1e4d90981a535': `Del dette dokument`,
'sfdeef3dccf409f81': `Dette nøgleord er påkrævet for widgets`,
'sfe6e758ad2603c1d': `Master`,
'sfee1c12daf838935': `Farveforbrænding`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Indsæt en dialog`,
'sffa395f64ec6ac36': `Bulgarsk`,
'sffdadf0a576fd802': `Højde`,
'spaceKey': `Rummet`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Op`,
'scbf29ce484222325': ``,
    };
  